<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <!-- {{ tabs }} -->
            <a-col :md="6" :sm="24">
              <a-form-item label="所属管线" prop="pipelineId">
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  @change="pipelineIdChange"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in pipelineList" :key="item.id" :value="item.id">
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="请选择设备" prop="deviceId">
                <a-select
                  mode="multiple"
                  v-model="queryParam.deviceIds"
                  style="width: 100%"
                  placeholder="请选择设备"
                  @change="handleChange"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in deviceList" :key="item.id" :value="item.id" :title="item.locationDescription+' - '+ item.deviceCode">
                    {{ item.locationDescription }} - {{ item.deviceCode }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="时间区间">
                <CyRangePicker
                  :start.sync="queryParam.createBeginTime"
                  :end.sync="queryParam.createEndTime"
                  @change="getPage"
                />
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="getPage"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <a-tabs v-model="tabs" @change="callback">
          <a-tab-pane v-for="item in tabsOptions" :key="item.key" :tab="item.name">
            <div>
              <div class="pubLoading" v-if="!showLoading">
                <a-icon slot="indicator" type="loading" style="font-size: 80px" spin />
              </div>
              <div v-if="showLoading">
                <div v-if="list && list.length">
                  <div v-for="item in list" :key="item.deviceId" class="cy-chart">
                    <CyChart :chartData="item.chartData"></CyChart>
                  </div>
                </div>
                <div class="kong" v-else>
                  <img src="~@/assets/images/kong.png" alt="" />
                  <div>暂无数据</div>
                </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDeviceData, listPipeline, listDevice, listChart } from '@/api/saifuneng/devicedata'
import { tableMixin } from '@/store/table-mixin'
import CyChart from '@/components/CyChart'
import CyRangePicker from '@/components/CyRangePicker'
import moment from 'moment'
export default {
  name: 'DeviceData',
  components: {
    CyChart,
    CyRangePicker
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      pipelineList: [],
      showLoading: true,
      deviceList: [],
      selectedRowKeys: [],
      monthPickShow: false,
      chartDatas: {},
      selectedRows: [],
      optionsX: [],
      options: [
        {
          id: 1,
          name: '30分钟'
        },
        {
          id: 2,
          name: '1小时'
        },
        {
          id: 3,
          name: '3小时'
        },
        {
          id: 4,
          name: '6小时'
        },
        {
          id: 5,
          name: '9小时'
        },
        {
          id: 6,
          name: '24小时'
        }
      ],
      option: [
        {
          id: 0,
          name: '即时'
        },
        {
          id: 1,
          name: '日'
        },
        {
          id: 2,
          name: '月'
        },
        {
          id: 3,
          name: '年'
        }
      ],
      optionY: [
        {
          id: 0,
          name: '平均值'
        },
        {
          id: 1,
          name: '最小值'
        },
        {
          id: 2,
          name: '最大值'
        }
      ],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pipelineId: undefined,
        deviceCategorizeCode: 'electric_drainage',
        deviceIds: [],
        queryType: 6,
        createBeginTime: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
        createEndTime: moment().endOf('day').format('YYYY-MM-DD 23:59:59')
      },
      value: [],
      value2: [],
      value1: [],
      chartData: {},
      tabs: 1,
      tabsOptions: [
        {
          key: 1,
          name: '管道接地电压差',
          keys: {
            acInterferenceVoltage: '管道对接地电压差（交流电压）（v/vrms）',
            electrifiedPotential: '管道对接地电压差（直流电压）（V）'
          }
        },
        {
          key: 2,
          name: '流经排流',
          keys: {
            acCurrentFlowingThroughTheTestPiece: '流经排流交流电流（A）',
            directCurrentFlowingThroughTheTestPiece: '流经排流直流电流（A）'
          }
        },
        {
          key: 3,
          name: '电池电压',
          keys: {
            batteryVoltage: '电池电压（V）'
          }
        }
      ]
    }
  },
  filters: {},
  created() {
    // this.getPage()
    this.getPipelineList()
    this.getDeviceList(null)
  },
  computed: {},
  watch: {},
  methods: {
    callback(key) {
      this.showLoading = false
      console.log(key)
      this.list = []

      this.getPage()
    },
    onChange(e) {
      this.queryParam.startTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm')
      this.queryParam.endTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm')
    },
    handleChangeTime(e) {
      this.queryParam.startTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    handleChangeTimes(e) {
      this.queryParam.startTimeContrast = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTimeContrast = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    handleChanges(e) {
      // this.getPage()
      // this.list = []
      if (this.tabs == 2 || this.tabs == 4) {
        if (e == 0) {
          this.queryParam.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.startTime = moment(new Date()).subtract(0, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        } else if (e == 1) {
          this.queryParam.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.startTime = moment(new Date()).subtract(3, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        } else if (e == 2) {
          this.queryParam.endTime = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.startTime = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
        } else if (e == 3) {
          this.queryParam.endTime = moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
          this.queryParam.startTime = moment().startOf('year').format('YYYY-MM-DD HH:mm:ss')
        }
        this.value1 = [this.queryParam.startTime, this.queryParam.endTime]
      }
    },
    getPages() {
      this.showLoading = false
      this.getPage()
      this.$forceUpdate()
    },
    getPage() {
      if (this.queryParam.deviceIds.length == 0) {
        this.showLoading = true
        return
      }
      this.showLoading = false
      // if ((this.tabs ！== '5' || this.tabs ！== '6') && this.queryParam.deviceIds.length === 0) return
      listChart(this.queryParam).then((res) => {
        // res = res.data
        // this.getDate(res.dataList, 1, res)
        console.log('listChart>>>>>>>>', res)
        this.showLoading = true
        this.list = res.data
        const tabsObj = this.tabsOptions.find((item) => item.key == this.tabs).keys
        this.list.map((item) => {
          item.chartData = {
            title: item.locationDescription + '-' + item.deviceCode,
            xData: item.chartDataList.map((child) => child.deviceTime),
            yData: Object.keys(tabsObj).map((key) => ({
              name: tabsObj[key],
              type: 'line',
              data: item.chartDataList.map((child) => child[key])
            }))
          }
        })
      })
    },
    handleOpenChange(status) {
      if (status) {
        this.monthPickShow = true
      } else {
        this.monthPickShow = false
      }
    },
    handlePanelChange2(value, mode) {
      if (this.value1[1] && this.value1[1]._d != value[1]._d) {
        this.monthPickShow = false
      }
      this.value1 = value
      console.log(value, 'valuevaluevalue===')
      this.queryParam.startTime = moment(value[0]).format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(value[1]).format('YYYY-MM-DD HH:mm:ss')
      // this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
    },
    getDate(date, e, res) {
      date.forEach((v) => {
        console.log(v, '大大大大大===')
        const arr = []
        const arr1 = []
        const arr2 = []
        const time = []
        const sacrificialAnodeVoltage = []
        const selfCorrosionPotential = []
        v.chartDataList.forEach((item) => {
          time.push(item.x)
          if (e == 3 || e == 4) {
            arr.push(item.y)
          } else {
            arr.push(item.y1)
            arr1.push(item.y2)
          }
          if (e == 2) {
            sacrificialAnodeVoltage.push(item.sacrificialAnodeVoltage)
            selfCorrosionPotential.push(item.selfCorrosionPotential)
          }
          if (e == 7) {
            arr2.push(item.y3)
          }
        })
        if (e == 1 || e == 2) {
          v.chartData = {
            time: time,
            y1: arr,
            y2: arr1,
            name: v.locationDescription,
            limitMax1: res.limitMax1,
            limitMax2: res.limitMax2,
            limitMin1: res.limitMin1,
            limitMin2: res.limitMin2
          }
          if (e == 2) {
            v.chartData.selfCorrosionPotential = selfCorrosionPotential
            v.chartData.sacrificialAnodeVoltage = sacrificialAnodeVoltage
          }
        } else if (e == 3 || e == 4) {
          v.chartData = {
            time: time,
            y1: arr,
            name: v.locationDescription,
            limitMax1: res.limitMin,
            limitMax2: res.limitMax
          }
        } else if (e == 7) {
          v.chartData = {
            time: time,
            y1: arr,
            y2: arr1,
            y3: arr2
          }
        }
        console.log(v.chartData, res, '111chartDatachartData')
      })
      console.log(this.list, 'chartDatachartData')
      this.list = res.dataList
      this.showLoading = true
      this.$forceUpdate()
    },
    /** 查询设备信息列表 */
    getList() {
      this.loading = true
      pageDeviceData(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getPage()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.list = []
      this.queryParam = {
        pipelineId: undefined,
        deviceCategorizeCode: 'electric_drainage',
        deviceIds: [],
        queryType: 6,
        createBeginTime: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
        createEndTime: moment().endOf('day').format('YYYY-MM-DD 23:59:59'),
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    getPipelineList() {
      listPipeline().then((response) => {
        this.pipelineList = response.data
      })
    },
    handleChange(e) {
      console.log(e, '大大大大大')
      if (e.length) {
        this.getPage()
      }
    },
    pipelineIdChange(value) {
      this.getDeviceList(value)
      this.queryParam.deviceIds = []
    },
    getDeviceList(pipelineId) {
      listDevice({ pipelineId: pipelineId, deviceCategorizeCode: 'electric_drainage' }).then((response) => {
        this.deviceList = response.data
        // if (response.data.length) {
        //   this.queryParam.deviceIds[0] = response.data[0].id
        //   console.log(this.queryParam, '大大大大大=========')
        //   // this.getPage()
        // } else {
        //   this.queryParam.deviceIds = []
        // }
        // console.log(response.data, 'response.dataresponse.data')
        // if (this.queryParam.deviceIds.length) this.getPage()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
<style lang="less" scoped>
.fanwei {
  display: flex;
  align-items: center;

  .ant-input-affix-wrapper {
    &:first-child {
      margin-right: 10px;
    }
  }
}

.kong {
  text-align: center;
}

.pubLoading {
  text-align: center;
}
.cy-chart {
  height: 500px;
}
</style>
